import { Component } from '@angular/core';
import { SafeUrlPipe } from '../../../safe-url.pipe';

@Component({
  selector: 'app-learning',
  templateUrl: './learning.component.html',
  styleUrls: ['./learning.component.scss'],
  providers: [SafeUrlPipe]
})
export class LearningComponent {
  videoUrl = 'https://global-upload-storage.s3.us-east-1.amazonaws.com/crm/leads/attachments/Manage+Leads+-+Personal+-+Microsoft%E2%80%8B+Edge+2025-11-07+00-17-29.mp4';
}
